import ClientConstants from './ClientConstants/Bavet';
export default ClientConstants 
/*{
    public static readonly IDENTITY = "https://api.flyx.cloud/bkbe/identity";
    public static readonly CLIENT_PRIMARY_COLOR = "#eb4034";
    public static readonly CLIENT_NAME = "BurgerKingBelgium";
    public static readonly CLIENT_IMAGE = "https://upload.wikimedia.org/wikipedia/fr/thumb/d/d4/Burger_King.svg/1200px-Burger_King.svg.png";
}*/